import React from 'react';
import ContactForm from '../contact';

const SubscriberInfo = ({ formData, handleChange, setFormData }) => {

  const formattedAmount = formData.amount ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(formData.amount) : '';

  const labelWidth = 150;
  const paddingOffset = 60;

  const inputStyle = {
    padding: '6px 10px',
    width: `calc(100vw - ${labelWidth + paddingOffset}px)`,
    maxWidth: '550px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box'
  };

  const rowStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '5px',
  };

  const labelStyle = {
    minWidth: `${labelWidth}px`,
    marginRight: '10px',
    textAlign: 'left',
    whiteSpace: 'normal',
    lineHeight: '1.2',
    paddingTop: '4px',
  };

  const groupedInputContainerStyle = {
    display: 'flex',
    gap: '9px',
    width: `calc(100vw - ${labelWidth + paddingOffset}px)`,
    maxWidth: '550px',
    boxSizing: 'border-box',
  };

  const groupedInputStyle = {
    padding: '6px 10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box',
    minWidth: 0
  };

  const jointSubscriber =
  formData?.investorType === "jointSpouse" &&
  formData.subscriberName1 &&
  formData.subscriberName2
    ? `${formData.subscriberName1} and ${formData.subscriberName2} as joint tenants`
    : "";

  const subscriberName1Colon =
  formData?.subscriberName1 ? `: ${formData.subscriberName1}` : "";

  const subscriberName2Colon =
  formData?.subscriberName2 ? `: ${formData.subscriberName2}` : "";


  return (
    <div>

      <br />

      <div>
        <h4>
          IN WITNESS WHEREOF, the Subscriber has executed this Subscription Agreement as of  
          <input
            type="date"
            name={formData.investorType === "entity" ? "selectedDateEntity" : "selectedDate"}
            value={
              formData.investorType === "entity"
                ? formData.selectedDateEntity || ""
                : formData.selectedDate || ""
            }
            onChange={(e) => handleChange(e, setFormData)}
            style={{ width: '8%', padding: '5px', marginLeft: '10px' }}
            required
          />
        </h4>
      </div>

      <h4>
        FOR COMPLETION BY ALL SUBSCRIBERS:
      </h4>

      <p style={{ marginLeft: '0px', display: 'flex', alignItems: 'center' }}>
        <label>Subscriber’s Commitment Amount: </label>
        <input 
          type="text" 
          name="amount" 
          value={formData.amount || ""} 
          onChange={handleChange} 
          placeholder="Enter amount ($)" 
          style={{ width: '15%', padding: '5px', marginLeft: '10px' }} 
          required 
        />
        <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
          {formattedAmount}
        </span>
      </p>

      <div style={{ display: 'flex', gap: '40px', padding: '20px' }}>
        {/* Formal Notice */}
        <div style={{ width: '48%' }}>
          <h4 style={{ marginBottom: '16px' }}>
            Subscriber’s Formal Notice Information:
            <br />
            <small>(to be used for formal notice)</small>
          </h4>
          <div>
            <div style={rowStyle}>
              <label htmlFor="address" style={{ ...labelStyle, textAlign: 'right' }}>Address:</label>
              <input type="text" name="address" id="address" value={formData.address || ""} onChange={handleChange} placeholder="Street Address" style={inputStyle} required/>
            </div>
            <div style={rowStyle}>
              <label htmlFor="address2" style={labelStyle}></label>
              <input type="text" name="address2" id="address2" value={formData.address2 || ""} onChange={handleChange} placeholder="Apt or Suite" style={inputStyle} />
            </div>
            <div style={rowStyle}>
              <label htmlFor="city" style={labelStyle}></label>
              <div style={groupedInputContainerStyle}>
                <input type="text" name="city" id="city" value={formData.city || ""} onChange={handleChange} placeholder="City" required style={{ ...groupedInputStyle, flex: 3 }} />
                <input type="text" name="state" id="state" value={formData.state || ""} onChange={handleChange} placeholder="State" required style={{ ...groupedInputStyle, flex: 1 }} />
                <input type="text" name="zip" id="zip" value={formData.zip || ""} onChange={handleChange} placeholder="Zip" required style={{ ...groupedInputStyle, flex: 2 }} />
              </div>
            </div>

            <div style={rowStyle}>
              <label htmlFor="attention" style={{ ...labelStyle, textAlign: 'right' }}>Attention:</label>
              <input type="text" name="attention" id="attention" value={formData.attention || ""} onChange={handleChange} placeholder="Name" style={inputStyle} />
            </div>
            <div style={rowStyle}>
              <label htmlFor="phone" style={{ ...labelStyle, textAlign: 'right' }}>Phone No.:</label>
              <input type="text" name="phone" id="phone" value={formData.phone || ""} onChange={handleChange} placeholder="Phone Number" style={inputStyle} required/>
            </div>
            <div style={rowStyle}>
              <label htmlFor="email" style={{ ...labelStyle, textAlign: 'right' }}>E-mail:</label>
              <input type="email" name="email" id="email" value={formData.email || ""} onChange={handleChange} placeholder="Email" style={inputStyle} required/>
            </div>
          </div>
        </div>

        {/* Other Contact */}
        <div style={{ width: '48%' }}>
          <h4 style={{ marginBottom: '16px' }}>
            Subscriber’s Other Contact Information:
            <br />
            <small>(e.g., home, business or main office)</small>
          </h4>
          <div>
            <div style={rowStyle}>
              <label htmlFor="otherAddress" style={{ ...labelStyle, textAlign: 'right' }}>Address:</label>
              <input type="text" name="otherAddress" id="otherAddress" value={formData.otherAddress || ""} onChange={handleChange} placeholder="Street Address" style={inputStyle} />
            </div>
            <div style={rowStyle}>
              <label htmlFor="otherAddress2" style={labelStyle}></label>
              <input type="text" name="otherAddress2" id="otherAddress2" value={formData.otherAddress2 || ""} onChange={handleChange} placeholder="Apt or Suite" style={inputStyle} />
            </div>
            <div style={rowStyle}>
              <label htmlFor="otherCity" style={labelStyle}></label>
              <div style={groupedInputContainerStyle}>
                <input type="text" name="otherCity" id="otherCity" value={formData.otherCity || ""} onChange={handleChange} placeholder="City" style={{ ...groupedInputStyle, flex: 3 }} />
                <input type="text" name="otherState" id="otherState" value={formData.otherState || ""} onChange={handleChange} placeholder="State" style={{ ...groupedInputStyle, flex: 1 }} />
                <input type="text" name="otherZip" id="otherZip" value={formData.otherZip || ""} onChange={handleChange} placeholder="Zip" style={{ ...groupedInputStyle, flex: 2 }} />
              </div>
            </div>

            <div style={rowStyle}>
              <label htmlFor="otherAttention" style={{ ...labelStyle, textAlign: 'right' }}>Attention:</label>
              <input type="text" name="otherAttention" id="otherAttention" value={formData.otherAttention || ""} onChange={handleChange} placeholder="Name" style={inputStyle} />
            </div>
            <div style={rowStyle}>
              <label htmlFor="otherPhone" style={{ ...labelStyle, textAlign: 'right' }}>Phone No.:</label>
              <input type="text" name="otherPhone" id="otherPhone" value={formData.otherPhone || ""} onChange={handleChange} placeholder="Phone Number" style={inputStyle} />
            </div>
            <div style={rowStyle}>
              <label htmlFor="otherEmail" style={{ ...labelStyle, textAlign: 'right' }}>E-mail:</label>
              <input type="email" name="otherEmail" id="otherEmail" value={formData.otherEmail || ""} onChange={handleChange} placeholder="Email" style={inputStyle} />
            </div>
          </div>
        </div>
      </div>

      <ContactForm formData={formData} handleChange={handleChange} setFormData={setFormData} />
      
      {formData.investorType !== "selfDirectedIRA" && formData.investorType !== "revocableGrantorTrust" && (        
      <h4>
        FOR COMPLETION BY SUBSCRIBERS WHO ARE NATURAL PERSONS:
        <br />
        (i.e., individuals)
      </h4>
      )}

      {formData.investorType !== "selfDirectedIRA" && formData.investorType !== "revocableGrantorTrust" && formData.investorType !== "jointSpouse" && (      
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          marginBottom: '12px',
        }}
      >
        <label
          htmlFor="subscriberName"
          style={{
            minWidth: `${labelWidth}px`,
            marginRight: '10px',
            textAlign: 'left',
            whiteSpace: 'normal',
            lineHeight: '1.2',
            paddingTop: '4px',
          }}
        >
          Subscriber's Name:
        </label>
        <input
          type="text"
          id="subscriberName"
          name="subscriberName"
          value={formData.subscriberName || ""}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder={"Subscriber Name"}
          readOnly={formData.investorType === "entity"}
          disabled={formData.investorType === "entity"}
          required={
            formData.investorType === "individual" &&
            !formData.subscriberNameEntityInd &&
            !formData.subscriberName
          }
          style={{
            padding: '6px 10px',
            width: `300px`,
            maxWidth: '600px',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        />
              
      </div>
      )}
      
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
  {formData.investorType === "jointSpouse" && (
    <>
      <label
        htmlFor="subscriberName"
        style={{
          minWidth: `${labelWidth}px`,
          marginRight: '10px',
          textAlign: 'left',
          whiteSpace: 'nowrap',
          lineHeight: '1.2',
          paddingTop: '4px',
        }}
      >
        Subscriber's Name:
      </label>

      <input
        type="text"
        id="subscriberName1"
        name="subscriberName1"
        value={formData.subscriberName1 || ""}
        onChange={(e) => handleChange(e, setFormData)}
        placeholder="Spouse 1"
        readOnly={formData.investorType === "entity"}
        disabled={formData.investorType === "entity"}
        required={
          formData.investorType === "individual" &&
          !formData.subscriberNameEntityInd &&
          !formData.subscriberName1
        }
        style={{
          padding: '6px 10px',
          width: '200px',
          maxWidth: '300px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          marginRight: '5px',
        }}
      />

      <span style={{ margin: '0 5px' }}>and</span>

      <input
        type="text"
        id="subscriberName2"
        name="subscriberName2"
        value={formData.subscriberName2 || ""}
        onChange={(e) => handleChange(e, setFormData)}
        placeholder="Spouse 2"
        required={true}
        style={{
          padding: '6px 10px',
          width: '200px',
          maxWidth: '300px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          margin: '0 5px',
        }}
      />

      <span style={{ marginLeft: '5px' }}>as joint tenants</span>
    </>
  )}
</div>

{formData.investorType !== "individual" && formData.investorType !== "jointSpouse" && formData.investorType !== "entity" && (
  <>
    <h4>
      FOR COMPLETION BY SUBSCRIBERS WHO ARE NOT NATURAL PERSONS:
      <br />
      (i.e., corporations, partnerships, limited liability companies, trusts or other entities)
    </h4>

    <div style={rowStyle}>
      <label htmlFor="subscriberName" style={{ ...labelStyle, width: `${labelWidth}px` }}>
        Subscriber's Name:
      </label>
      <input
        type="text"
        id="subscriberNameEntityInd"
        name="subscriberNameEntityInd"
        value={formData.subscriberNameEntityInd || ""}
        onChange={handleChange}
        placeholder="Subscriber Name"
        required={
          (formData.investorType === "revocableGrantorTrust" || formData.investorType === "selfDirectedIRA") &&
          !formData.subscriberNameEntityInd
        }
        style={{
          ...inputStyle,
          width: '300px',
        }}
      />
    </div>

    <div style={rowStyle}>
      <label htmlFor="authorizedName" style={{ ...labelStyle, width: `${labelWidth}px` }}>
        Authorized Name:
      </label>
      <input
        type="text"
        id="authorizedName"
        name="authorizedName"
        value={formData.authorizedName || ""}
        onChange={handleChange}
        placeholder="Name of authorized representative"
        style={{
          ...inputStyle,
          width: '300px',
        }}
      />
    </div>

    <div style={rowStyle}>
      <label htmlFor="title" style={{ ...labelStyle, width: `${labelWidth}px` }}>
        Title:
      </label>
      <input
        type="text"
        id="title"
        name="title"
        value={formData.title || ""}
        onChange={handleChange}
        placeholder="Title of authorized representative"
        style={{
          ...inputStyle,
          width: '300px',
        }}
      />
    </div>

  </>
)}

{formData.investorType !== "individual" && formData.investorType !== "jointSpouse" && formData.investorType !== "revocableGrantorTrust" && formData.investorType !== "selfDirectedIRA" && (
  <>
    <h4>
      FOR COMPLETION BY SUBSCRIBERS WHO ARE NOT NATURAL PERSONS:
      <br />
      (i.e., corporations, partnerships, limited liability companies, trusts or other entities)
    </h4>

    <div style={rowStyle}>
      <label htmlFor="subscriberName" style={{ ...labelStyle, width: `${labelWidth}px` }}>
        Subscriber's Name:
      </label>
      <input
        type="text"
        id="subscriberName"
        name="subscriberNameEntity"
        value={formData.subscriberNameEntity || ""}
        onChange={handleChange}
        placeholder="Subscriber (Entity) Name"
        required={formData.investorType === "entity" && !formData.subscriberNameEntity}
        style={{
          ...inputStyle,
          width: '300px',
        }}
      />
    </div>

    <div style={rowStyle}>
      <label htmlFor="authorizedName" style={{ ...labelStyle, width: `${labelWidth}px` }}>
        Authorized Name:
      </label>
      <input
        type="text"
        id="authorizedNameEntity"
        name="authorizedNameEntity"
        value={formData.authorizedNameEntity || ""}
        onChange={handleChange}
        placeholder="Name of authorized representative"
        style={{
          ...inputStyle,
          width: '300px',
        }}
      />
    </div>

    <div style={rowStyle}>
      <label htmlFor="title" style={{ ...labelStyle, width: `${labelWidth}px` }}>
        Title:
      </label>
      <input
        type="text"
        id="titleEntity"
        name="titleEntity"
        value={formData.titleEntity || ""}
        onChange={handleChange}
        placeholder="Title of authorized representative"
        style={{
          ...inputStyle,
          width: '300px',
        }}
      />
    </div>

  </>
)}

    </div>
  );
};

export default SubscriberInfo;
